import TableComponent from "app/common/Component/Table/TableComponent";
import { useStore } from "app/stores";
import React, { memo, useState } from "react";
import { Grid, Tooltip, useMediaQuery, useTheme } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { getDateTime, isRoleHisReadOnly } from "app/common/LocalFunction";
import { observer } from "mobx-react";
import AssignmentIcon from "@material-ui/icons/Assignment";

const ListCheckIn = ({ patientId }) => {
  const { t } = useTranslation();
  const {
    searchCheckIn,
    pageCheckIn,
    handleChangeFormSearch,
    setSelectedCheckIn,
    handleGetEncounterDiagnosis,
    selectedCheckin,
  } = useStore().patientManagementStore.encounterDiagnosisStore;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const isReadonly = isRoleHisReadOnly();
  return (
    <>
      <Grid
        container
        spacing={1}
        className="justify-center cards-body"
        style={{
          paddingTop: 0,
          paddingBottom: 0,
          zIndex: 1,
          position: "relative",
        }}
      >
        <Grid item sm={12} style={isMobile ? { width: "100%" } : {}}>
          <TableComponent
            showOrdinalNumbers
            titleNodata={t("noData")}
            data={pageCheckIn?.content || []}
            getRowStyle={(row) => ({
              backgroundColor:
                row?.visitId === selectedCheckin?.visitId
                  ? "#cce5ff"
                  : "transparent",
            })}
            columns={[
              !isReadonly && {
                title: t("action"),
                field: "action",
                align: "center",
                render: (row) => (
                  <div className="flex-center gap-2">
                    <Tooltip title="Thực hiện khám">
                      <div
                        className="flex items-center cursor-pointer text-blue"
                        onClick={() => {
                          setSelectedCheckIn(row);
                          handleGetEncounterDiagnosis({
                            visitId: row?.visitId,
                            patientId,
                            encounterDatetime: row?.encounterDatetime,
                          });
                        }}
                      >
                        <AssignmentIcon />
                      </div>
                    </Tooltip>
                  </div>
                ),
              },

              {
                field: "checkin",
                title: t("Thời gian check in"),
                render: (val) => getDateTime(val?.encounterDatetime),
              },
              {
                field: "checkin",
                title: t("Thời gian check out"),
                render: (val) => getDateTime(val?.visitStopDateTime),
              },
              {
                field: "practitioner.staffName",
                title: t("Người check in"),
              },
              {
                field: "currentVisitDepName",
                title: t("Cơ sở checkin"),
              },
              {
                field: "creatby ",
                title: t("Người tạo"),
              },
            ].filter(Boolean)}
            dataPagination={{
              pageIndex: searchCheckIn?.pageIndex,
              pageSize: searchCheckIn?.pageSize,
              totalElements: pageCheckIn?.totalElements,
              totalPages: pageCheckIn?.totalPages,
              setPageIndex: (pageIndex) =>
                handleChangeFormSearch({ pageIndex }),
              setPageSize: (pageSize) => handleChangeFormSearch({ pageSize }),
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default memo(observer(ListCheckIn));
